var exports = {
  "k": "xdde3148b--13be6c--container",
  "v": "xdde3148b--13be6c--inner",
};

module.exports = exports;
